(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6829],{

/***/ 45207:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/app",
      function () {
        return __webpack_require__(85362);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AppPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Page.tsx
var Page = __webpack_require__(61582);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./src/components/animate/index.ts + 12 modules
var animate = __webpack_require__(76843);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(32970);
// EXTERNAL MODULE: ./src/layouts/index.tsx + 45 modules
var layouts = __webpack_require__(72575);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/sections/apps/types.ts
var StandoutFeatureType;
(function(StandoutFeatureType) {
    StandoutFeatureType["timeSpent"] = "timeSpent";
    StandoutFeatureType["earningInUsd"] = "earningInUsd";
    StandoutFeatureType["monthlyEarningInUsd"] = "monthlyEarningInUsd";
    StandoutFeatureType["infinitePossibleValues"] = "infinitePossibleValues";
})(StandoutFeatureType || (StandoutFeatureType = {}));

// EXTERNAL MODULE: ./src/routes/paths.ts
var paths = __webpack_require__(96259);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(99062);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/theme/palette.ts
var palette = __webpack_require__(78187);
;// CONCATENATED MODULE: ./src/sections/apps/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 50% 50%;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ListContainer = (0,styled/* default */.ZP)("div")(_templateObject());
var StyledCard = (0,styled/* default */.ZP)(Card/* default */.Z)(_templateObject1(), palette/* shinyCss */.kN);
function AppServiceCard(props) {
    var _appPageServiceConfig = props.appPageServiceConfig, appUrl = _appPageServiceConfig.appUrl, title = _appPageServiceConfig.title, description = _appPageServiceConfig.description, forceDisable = _appPageServiceConfig.forceDisable, standoutFeatures = _appPageServiceConfig.standoutFeatures, featured = _appPageServiceConfig.featured;
    var sharedCardProps = {
        sx: {
            p: 5,
            boxShadow: 0
        }
    };
    var sharedComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                component: "h1",
                color: forceDisable ? "gray" : "inherit",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "caption",
                component: "h3",
                color: forceDisable ? "gray" : "inherit",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    borderStyle: "dashed"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            standoutFeatures.map(function(standoutFeature) {
                var component = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
                var sharedTypographyProps = {
                    variant: "h6"
                };
                switch(standoutFeature.type){
                    case StandoutFeatureType.timeSpent:
                        {
                            component = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedTypographyProps), {
                                        children: "Time Spend"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "right"
                                    }, sharedTypographyProps), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            label: "".concat(standoutFeature.timeSpentInMinutes, " Minutes"),
                                            size: "medium"
                                        })
                                    }))
                                ]
                            });
                            break;
                        }
                    case StandoutFeatureType.earningInUsd:
                        {
                            component = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedTypographyProps), {
                                        children: "Estimate Earning In USD"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "right"
                                    }, sharedTypographyProps), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            label: "".concat(standoutFeature.amount, " USD"),
                                            size: "medium"
                                        })
                                    }))
                                ]
                            });
                            break;
                        }
                    case StandoutFeatureType.monthlyEarningInUsd:
                        {
                            component = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedTypographyProps), {
                                        children: "Estimate Monthly Earning In USD"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "right"
                                    }, sharedTypographyProps), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            label: "".concat(standoutFeature.amount, " USD"),
                                            size: "medium"
                                        })
                                    }))
                                ]
                            });
                            break;
                        }
                    case StandoutFeatureType.infinitePossibleValues:
                        {
                            component = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedTypographyProps), {
                                        children: "Outcome"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "right"
                                    }, sharedTypographyProps), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            label: "Up to your imagination",
                                            size: "medium"
                                        })
                                    }))
                                ]
                            });
                            break;
                        }
                    default:
                        break;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                    children: component
                }, standoutFeature.type);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(paths/* PATH_APP_SERVICES.root */.lO.root).concat(appUrl),
                passHref: true,
                prefetch: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: forceDisable !== null && forceDisable !== void 0 ? forceDisable : false,
                    size: "large",
                    fullWidth: true,
                    variant: "outlined",
                    href: "".concat(paths/* PATH_APP_SERVICES.root */.lO.root).concat(appUrl),
                    LinkComponent: "a",
                    children: !forceDisable ? "Launch" : "Premium Only"
                })
            })
        ]
    });
    if (featured) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedCardProps), {
            children: sharedComponent
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedCardProps), {
        children: sharedComponent
    }));
}

;// CONCATENATED MODULE: ./src/pages/_sites/[appId]/app/index.tsx











var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(3)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11),
        paddingBottom: theme.spacing(5)
    });
});
AppPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function AppPage(props) {
    var theme = (0,useTheme/* default */.Z)();
    var _appPageServiceConfigs = props.appPageServiceConfigs, appPageServiceConfigs = _appPageServiceConfigs === void 0 ? [] : _appPageServiceConfigs;
    var featuredAppPageServiceConfigs = appPageServiceConfigs.filter(function(appPageServiceConfig) {
        return appPageServiceConfig.featured;
    });
    var nonFeaturedAppPageServiceConfigs = appPageServiceConfigs.filter(function(appPageServiceConfig) {
        return !appPageServiceConfig.featured;
    });
    var sharedBoxProps = {
        sx: {
            textAlign: "center",
            mb: 5,
            mt: 10
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: "AI Tools - Store",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
            children: [
                featuredAppPageServiceConfigs.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    component: animate/* MotionViewport */.DG,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedBoxProps), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().inUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    sx: {
                                        mb: 2,
                                        color: theme.palette.primary.main
                                    },
                                    children: "Featured Services"
                                })
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 5,
                            children: featuredAppPageServiceConfigs.map(function(appPage) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppServiceCard, {
                                        appPageServiceConfig: appPage
                                    })
                                }, appPage.appUrl);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    component: animate/* MotionViewport */.DG,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedBoxProps), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().inUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    sx: {
                                        mb: 2,
                                        color: theme.palette.primary.main
                                    },
                                    children: "Services"
                                })
                            })
                        })),
                        nonFeaturedAppPageServiceConfigs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 5,
                            children: nonFeaturedAppPageServiceConfigs.map(function(appPage) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppServiceCard, {
                                        appPageServiceConfig: appPage
                                    })
                                }, appPage.appUrl);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                mb: 2,
                                textAlign: "center",
                                letterSpacing: "0.25rem"
                            },
                            children: "No enabled service"
                        })
                    ]
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,5073,8424,6755,3907,2575,9774,2888,179], function() { return __webpack_exec__(45207); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);